import { Injectable } from '@angular/core';
import { OnboardingBusinessConfigStore } from './business-config/business-config.store';
import { OnboardingRegistrationStore } from './registration/registration.store';

@Injectable()
export class OnboardingStore {
  constructor(
    public registration: OnboardingRegistrationStore,
    public businessConfig: OnboardingBusinessConfigStore
  ) {}
}
